<template>
    <!-- Control Menu -->
    <div class="d-flex align-items-center  justify-content-between  header">
        <img src="@/assets/images/logo/logoNewDark.png" width="100px" @click="goHome" />
        <feather-icon class="text-white mr-2" icon="BellIcon" size="35" @click="noAlertsMsg()" v-if="!hasAlerts"/>
        <feather-icon :badge="qtyAlerts" badge-classes="bg-danger" class="text-white mr-2" icon="BellIcon" size="35" @click="goAlerts" v-if="hasAlerts"/>
    </div>
</template>
<script>
import { BLink } from 'bootstrap-vue'
import router from 'vue-router'
export default {
    components: {
        BLink,
        router,

    },
    data() {
        return {
            hasAlerts:true,
            qtyAlerts:0,
        }
    },
    methods: {
        goHome(){
            this.$router.push('/');
        },
        goAlerts(){
            this.$router.push('/alerts');
        },
        previous: () => {
            history.back();
        },
        logout(){
            localStorage.removeItem('userID');
            localStorage.removeItem('accessToken');
            localStorage.removeItem('userMeta');
            localStorage.removeItem('userData');
            localStorage.removeItem('currentFarm');
            localStorage.removeItem('currentFarmName');
            localStorage.removeItem('refreshToken');
            this.$router.push('/login');
        },
        async fetchAlerts(config){
            let farmId= localStorage.getItem('currentFarm');
            const today = new Date();
            today.setHours(0, 0, 0, 0); // Set time to the start of the day
            if (farmId>0){
                fetch(this.$apiUrl+"list/AnimalsAlertsView?recperpage=all&farm_id="+farmId+"&state=0", config)
                .then(response => response.json())
                .then(result => {
                    console.log(result.AnimalsAlertsView);
                    if(result.AnimalsAlertsView.filter(item => new Date(item.date) <= today).length>0){
                        this.hasAlerts=true;
                        this.qtyAlerts=result.AnimalsAlertsView.filter(item => new Date(item.date) <= today).length;
                    }else{
                        this.hasAlerts=false;
                    }
                })
            }
            
        },
        noAlertsMsg(){
            this.$swal({
                title: 'No tiene alertas',
                text: 'No se encontraron alertas para esta finca.',
                type: 'success',
                icon:'success',
                showCancelButton: false,
                confirmButtonColor:'#5E8F23',
                showCloseButton: true,
                showLoaderOnConfirm: false  
            });
        }
    },
    created() {
        const token = localStorage.getItem("accessToken");
        const config = {headers: {"X-Authorization": `Bearer ${token}`}};
        this.fetchAlerts(config);
    }
}
</script>
<style lang="scss">
.header {
    z-index: 1;
    height: 50px;
    left: 1px;
    position: fixed;
    top: 0px;
    right: 0px;
    background: #5E8F23;
    box-shadow: 0px -3px 10px rgba(0, 0, 0, 0.57);
}
.badge.badge-up {
    right: auto !important;
    top:5px !important;
}

</style>